<template>
<div class="l-flex-grid">
  <template
    v-for="(item, index) in list">
      <div
      :key="index"
      class="u-grow u-border u-full l-flex-grid--no-wrap u-p2 u-mb2 l-flex-grid--v-center">
      <fa-icon
        class="u-mr2 u-icon--light"
        icon="paperclip" />
      <span class="u-truncate u-3of4">
        {{item.fileName}}
      </span>
      <fa-icon
        class="u-ml-auto u-icon--light"
        icon="arrow-to-bottom" />
    </div>
  </template>
</div>
</template>

<script>
export default {
  name: 'AttachmentsList',
  props: {
    list: {
      default: () => [],
      type: Array
    }
  }
}
</script>
